import React from 'react';
import {
  Typography,
  Container,
  Card,
  CardContent,
} from '@mui/material';
import { CheckCircle } from '@mui/icons-material';

const FeedbackThankYou: React.FC = () => {
  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Card>
        <CardContent sx={{ p: 4, textAlign: 'center' }}>
          <CheckCircle 
            sx={{ 
              fontSize: 80, 
              color: 'success.main', 
              mb: 2 
            }} 
          />
          
          <Typography variant="h4" component="h1" gutterBottom>
            Thank You!
          </Typography>
          
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Your feedback has been submitted successfully. We appreciate you taking the time to help us improve our service.
          </Typography>
          
          <Typography variant="body2" color="text.secondary">
            If you have any other questions or concerns, please don't hesitate to contact our support team.
          </Typography>
        </CardContent>
      </Card>
    </Container>
  );
};

export default FeedbackThankYou;
